import React from "react";

export const LOGO_URL =
  "https://customer-assets-lxgj4vgw.emergentagent.net/job_customer-site-build/artifacts/3rjd9s1h_Carivisor%20Travel%20Navigator%20Icon.png";

export function LogoMark({ size = 40, className = "" }) {
  return (
    <img
      src={LOGO_URL}
      alt="Carivisor"
      width={size}
      height={size}
      className={`rounded-[22%] object-cover shadow-[0_0_22px_rgba(255,45,120,0.35)] ${className}`}
      style={{ width: size, height: size }}
    />
  );
}

export function Logo({ size = 40, showText = true, tagline = false, className = "" }) {
  return (
    <div className={`flex items-center gap-2.5 ${className}`}>
      <LogoMark size={size} />
      {showText && (
        <div className="leading-none">
          <span className="font-heading font-extrabold text-xl tracking-tight text-white">
            Cari<span className="text-gradient-warm">visor</span>
          </span>
          {tagline && (
            <span className="block font-mono-caption text-[9px] uppercase tracking-[0.22em] text-cyan-300 mt-0.5">
              See it. Book it. Go.
            </span>
          )}
        </div>
      )}
    </div>
  );
}

export default Logo;
